import { useMemo } from 'react';
import { endOfDay, isSameDay } from 'date-fns';
import { useFilters } from '../../contexts/filters/FiltersContext';

export const useProjectDates = () => {
  const { range } = useFilters();  

  const { startDate, endDate } = useMemo(() => {
    if (!range?.[0] || !range?.[1]) {
      return { startDate: null, endDate: null };
    }

    const now = new Date();
    const today = new Date();
    const rangeStart = new Date(range[0]);
    const rangeEnd = new Date(range[1]);
    const finalRangeEnd = isSameDay(rangeEnd, today) ? now : endOfDay(rangeEnd);

    return { startDate: rangeStart, endDate: finalRangeEnd };
  }, [range]);

  return { startDate, endDate };
};
